/* ==========================================================================
   Plant Store <> UnfoldCRO — Collection page behaviour

   Three jobs, all mobile:
     1. open/close the filter bottom sheet
     2. re-dock the sticky Filters/Sort bar into a floating pill once it
        scrolls out of its resting place
     3. keep the "Filter · N" badge and the sheet's "Show N products" button
        honest after facets.js swaps the grid

   Filtering itself is Dawn's facets.js — this never touches the query string.
   ========================================================================== */
(function () {
  'use strict';

  if (window.ufcCollectionBound) return;
  window.ufcCollectionBound = true;

  /* --- 0. The sort pill ---------------------------------------------------
     The select only covers part of the pill, so clicking the "Sort by" prefix
     or the caret did nothing. Delegated from the document because facets.js
     re-renders this markup on every filter change. */
  document.addEventListener('click', function (event) {
    var field = event.target.closest ? event.target.closest('.ufc-sort__field') : null;
    if (!field) return;
    // A click that already landed on the select opens it by itself; opening it
    // again here would close it straight away.
    if (event.target.closest('.ufc-sort__select')) return;

    var select = field.querySelector('.ufc-sort__select');
    if (!select) return;

    select.focus();
    // showPicker is the only reliable way to open a native select from script;
    // where it is missing, the focus above at least puts the keyboard on it.
    if (typeof select.showPicker === 'function') {
      try {
        select.showPicker();
      } catch (e) {
        /* Not allowed outside a user gesture in some browsers -- focus stands. */
      }
    }
  });

  function init() {
    var root = document.querySelector('.ufc-coll');
    if (!root) return;

    var bar = root.querySelector('[data-ufc-coll-bar]');
    var sheet = root.querySelector('[data-ufc-sheet]');
    var mobileForm = document.getElementById('FacetFiltersFormMobile');
    var countSource = document.getElementById('ProductCount');

    /* --- 1. Bottom sheet -------------------------------------------------- */

    function openSheet() {
      if (!sheet) return;
      sheet.hidden = false;
      document.body.classList.add('overflow-hidden');
      var closer = sheet.querySelector('[data-ufc-filters-close]');
      if (closer) closer.focus();
    }

    function closeSheet() {
      if (!sheet) return;
      sheet.hidden = true;
      document.body.classList.remove('overflow-hidden');
      var opener = root.querySelector('[data-ufc-filters-open]');
      if (opener) opener.focus();
    }

    root.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (event.target.closest('[data-ufc-filters-open]')) {
        event.preventDefault();
        openSheet();
        return;
      }
      // The "Remove all" link inside the sheet is a real navigation — let it be.
      var closer = event.target.closest('[data-ufc-filters-close]');
      if (closer && !closer.classList.contains('js-facet-remove')) {
        event.preventDefault();
        closeSheet();
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
    });

    /* --- 2. Dock the bar -------------------------------------------------- */

    if (bar && 'IntersectionObserver' in window) {
      // A spacer holds the bar's place in the flow so docking cannot shift
      // the page under the reader's finger.
      var sentinel = document.createElement('div');
      sentinel.className = 'ufc-coll__bar-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      bar.parentNode.insertBefore(sentinel, bar);

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var docked = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            if (docked === bar.classList.contains('is-docked')) return;
            sentinel.style.height = docked ? bar.offsetHeight + 'px' : '';
            bar.classList.toggle('is-docked', docked);
          });
        },
        { rootMargin: '0px 0px -100% 0px' }
      );

      observer.observe(sentinel);
    }

    /* --- 3. Keep the sort controls in step -------------------------------- */

    // A desktop filter/sort change submits FacetFiltersForm + FacetSortForm +
    // FacetSortDrawerForm together, so sort_by goes up twice. Shopify honours
    // the LAST occurrence, and the mobile select sits last in the DOM — so a
    // stale mobile value would quietly override every desktop sort. Mirror the
    // chosen value across both selects (and the mobile form's hidden input)
    // before facets.js's debounced handler reads the forms 800ms later.
    function mirrorSort(value) {
      document.querySelectorAll('select[name="sort_by"], [data-ufc-sort-mirror]').forEach(function (field) {
        if (field.value !== value) field.value = value;
      });
    }

    document.addEventListener('input', function (event) {
      var field = event.target;
      if (field && field.name === 'sort_by' && field.tagName === 'SELECT') mirrorSort(field.value);
    });

    /* --- 4. Keep the counts honest ---------------------------------------- */

    var filterLabel = root.querySelector('[data-ufc-filters-open]');
    var baseLabel = filterLabel ? filterLabel.textContent.split('·')[0].trim() : '';
    var showBtn = root.querySelector('[data-ufc-sheet] .ufc-sheet__btn--solid');
    var showTemplate = showBtn ? showBtn.textContent.trim() : '';

    function activeFilterCount() {
      var form = document.getElementById('FacetFiltersFormMobile');
      if (!form) return 0;

      var count = form.querySelectorAll('input[type="checkbox"]:checked').length;
      var priced = false;
      Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (input) {
        if (input.value !== '') priced = true;
      });
      return priced ? count + 1 : count;
    }

    function sync() {
      if (filterLabel && baseLabel) {
        var n = activeFilterCount();
        filterLabel.lastChild.textContent = n > 0 ? ' ' + baseLabel + ' · ' + n : ' ' + baseLabel;
      }

      if (showBtn && countSource) {
        // facets.js refreshes this dataset from every filtered response.
        var total = countSource.dataset.productCount;
        if (total) showBtn.textContent = showTemplate.replace(/\d[\d,]*/, total);
      }
    }

    if (mobileForm) mobileForm.addEventListener('change', sync);

    // The grid container is replaced wholesale on every filter change, which
    // is the most reliable signal that new counts have landed.
    var grid = document.getElementById('ProductGridContainer');
    if (grid && window.MutationObserver) {
      new MutationObserver(function () {
        loading = false;
        sync();
        bindInfinite();
      }).observe(grid, { childList: true });
    }

    /* --- 5. Infinite scroll ------------------------------------------------ */

    // The markup ships a real "next page" anchor, so this is pure enhancement:
    // with JS off the same link is click-through pagination and stays
    // crawlable. Everything lives inside #ProductGridContainer, which facets.js
    // replaces wholesale, so a filter change resets paging to page 1 by itself
    // — hence rebind() below rather than a one-time setup.
    var moreObserver = null;
    var loading = false;

    function loadNext(more) {
      var link = more.querySelector('[data-ufc-more-link]');
      if (!link || loading) return;

      loading = true;
      var spinner = more.querySelector('[data-ufc-more-spinner]');
      if (spinner) spinner.hidden = false;
      link.hidden = true;

      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (e) {
        loading = false;
        return;
      }
      // Ask for this section alone; the href already carries the active
      // filters and sort, so appended pages stay in the same result set.
      var gridEl = document.getElementById('product-grid');
      url.searchParams.set('section_id', gridEl.dataset.id);

      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var newGrid = parsed.getElementById('product-grid');
          var newMore = parsed.querySelector('[data-ufc-more]');
          if (!newGrid) throw new Error('no grid in response');

          var grid = document.getElementById('product-grid');
          while (newGrid.firstElementChild) {
            grid.appendChild(newGrid.firstElementChild);
          }

          if (newMore) {
            more.innerHTML = newMore.innerHTML;
            more.dataset.shown = newMore.dataset.shown || '';
            more.dataset.total = newMore.dataset.total || '';
          } else {
            more.innerHTML = '';
          }

          loading = false;

          // If the footer is still on screen after appending, keep going.
          if (more.querySelector('[data-ufc-more-link]')) {
            var box = more.getBoundingClientRect();
            if (box.top < window.innerHeight) loadNext(more);
          }
        })
        .catch(function () {
          // Leave the link in place so the reader can still page through.
          loading = false;
          if (spinner) spinner.hidden = true;
          var retry = more.querySelector('[data-ufc-more-link]');
          if (retry) retry.hidden = false;
        });
    }

    function bindInfinite() {
      var more = document.querySelector('[data-ufc-more]');
      if (moreObserver) {
        moreObserver.disconnect();
        moreObserver = null;
      }
      if (!more || !('IntersectionObserver' in window)) return;

      more.addEventListener('click', function (event) {
        var link = event.target.closest('[data-ufc-more-link]');
        if (!link) return;
        event.preventDefault();
        loadNext(more);
      });

      moreObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext(more);
          });
        },
        { rootMargin: '600px 0px' }
      );

      moreObserver.observe(more);
    }

    bindInfinite();

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
